import React, {useCallback} from 'react';
import Map from '../map2';
import {get, once} from 'lodash';
import {MuiThemeProvider} from '@material-ui/core/styles';
import theme from '../../theme';

interface HuntingLayerType extends LayerType {
    state_name: string;
    name: string;
}

interface HuntingMapPreviewProps {
    source: HuntingLayerType;
    baseSource: HuntingLayerType;
    bounds: mapboxgl.LngLatBoundsLike;
}

export default function HuntingMapPreview({source, baseSource, bounds}: HuntingMapPreviewProps) {
    const initializeMapboxHover = useCallback(once(({target: map}: {target: mapboxgl.Map}) => {
        const mapLayerId = `${source.uniqueTilecacheKey}__regions-fill`;
        const mapSourceId = `${source.uniqueTilecacheKey}__data`;
        const mapHoverLayerId = `${mapLayerId}__hover`;

        map.on('mousemove', mapLayerId, event => {
            map.getCanvas().style.cursor = 'pointer';
            map.setFilter(
                mapHoverLayerId,
                ['==', ['get', 'id'], get(event, 'features[0].properties.id')]
            );
        });

        map.on('mouseleave', mapLayerId, () => {
            map.getCanvas().style.cursor = '';
            map.setFilter(mapHoverLayerId, ['boolean', false]);
        });

        map.on('click', mapLayerId, event => {
            // eslint-disable-next-line max-len
            const url = '/hunting/' + source.state_name + '/' + source.uniqueTilecacheKey.substr(6) + '/' + get(event, 'features[0].properties.id');
            window.location.assign(url);
        });

        map.addLayer({
            id: mapHoverLayerId,
            type: 'fill',
            'source-layer': 'regions',
            source: mapSourceId,
            filter: ['boolean', false],
            paint: {
                'fill-color': 'rgba(0, 0, 255, 0.2)'
            }
        }, mapLayerId);
    }), []);

    return (<MuiThemeProvider theme={theme}>
        <div style={{
            margin: '0 auto',
            marginBottom: 20,
            height: 300,
            width: '100%',
            textAlign: 'left',
            maxWidth: 1200
        }}>
            <Map
                showGeolocateControl={false}
                layers={[
                    baseSource && {type: baseSource.uniqueTilecacheKey, opacity: 1},
                    {type: source.uniqueTilecacheKey, opacity: 1}
                ]}
                // @ts-ignore Remove when mapboxgl type definitions are available for 0.52.0
                options={bounds}
                style={{height: 300, width: '100%'}}
                // Prevent double tapping on map from zooming entire page on mobile #3338
                onTouchEnd={event => event.originalEvent.preventDefault()}
                onMapboxStyleChange={initializeMapboxHover}
            />
        </div>
    </MuiThemeProvider>
    );
}
